// src/shared/utils/router.ts

export const authRoute = (route: string) =>
  route.replace(/^\/auth\//, "");

export const appRoute = (route: string) =>
  route.replace(/^\/app\//, "");